import '@resources/fontes/fontes.css'
import React, { useEffect, useState } from 'react'
import Header from '@components/Header/Header'
import Sidebar from '@components/Sidebar/Sidebar'
import WelcomeHero from './components/WelcomeHero'
import FeatureCards from './components/FeatureCards'
import AboutSection from './components/AboutSection'
import CtaBanner from './components/CtaBanner'
import ContactSection from './components/ContactSection'
import VideoSection from './components/VideoSection'
import FooterSection from './components/FooterSection'

const HomeUser: React.FC<any> = () => {
  const [showVideoModal, setShowVideoModal] = useState(true)

  const handleCloseModal = () => setShowVideoModal(false)

  useEffect(() => {
    document.body.style.overflow = showVideoModal ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [showVideoModal])

  return (
    <>
      <div className="homeuser d-lg-flex justify-content-lg-center" style={{ minHeight: '100vh', backgroundColor: '#F8F9FB' }}>
        <Sidebar />
        <main className="with-fixed-nav">
          <Header showSidebarOpenButton />

          <div className="d-flex flex-column py-4 py-md-5" style={{ gap: 32 }}>
            <WelcomeHero />

            <FeatureCards />

            <CtaBanner />

            <AboutSection />

            <ContactSection />

            <VideoSection />

            <FooterSection />
          </div>
        </main>
      </div>

      {showVideoModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={handleCloseModal}>
          <div style={{ position: 'relative', width: 'min(1280px, 90vw)' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }} src="https://www.youtube.com/embed/eQq1wre7xHg" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>
            <button style={{ position: 'absolute', top: '-10px', right: '-10px', background: 'red', color: 'white', border: 'none', borderRadius: '50%', width: '30px', height: '30px', cursor: 'pointer' }} onClick={handleCloseModal}>×</button>
          </div>
        </div>
      )}
    </>
  )
}

export default HomeUser
